import * as React from 'react';
import { FieldProps, ErrorMessage } from 'formik';
import Select from 'react-select';
import { Box } from '../';
import { Label, Span } from '../../typography';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import tag from 'blacklist-tag';
import { SelectObject } from '../../utils/types';
import { theme } from '../../theme';

type CustomProps = StyledSystemProps & {
  options: SelectObject[];
  name: string;
  label?: string;
  color?: string;
  placeholder?: string;
  disabled?: boolean;
  isMulti?: boolean;
  isSearchable?: boolean;
  onChanged?: Function;
};

export const StyledSelect = styled(Select)`
  z-index: ${theme.zIndex[16]};
  & .react-select__control {
    min-height: 40px;
  }
  & .react-select__menu .react-select__menu-list .react-select__option--is-selected {
    background-color: ${themeGet('colors.putty', '#EEE')};
    z-index: ${theme.zIndex[16]};
    border-style: none;
  }

  & .react-select__control.react-select__control--is-disabled {
    opacity: 0.6;
    background-color: ${themeGet('colors.grayExtraLight', '#EEE')};
    box-shadow: ${themeGet('inputBoxShadow', '#EEE')};
    z-index: ${theme.zIndex[16]};
    border-style: none;
  }
  & .react-select__control--is-focused {
    border: solid 2px ${themeGet('colors.putty', '#EEE')};
    z-index: ${theme.zIndex[16]};
    box-shadow: none;
  }
  & .react-select__control:hover {
    border: solid 2px ${themeGet('colors.putty', '#EEE')};
    z-index: ${theme.zIndex[16]};
    box-shadow: none;
  }
`;

const StyledFormSelect: React.FC<FieldProps & CustomProps> = ({
  field,
  label,
  disabled,
  options,
  isMulti,
  form,
  onChanged,
  isSearchable,
  placeholder,
  ...rest
}) => {
  return (
    <Box {...rest}>
      {label && <Label htmlFor={field.name}>{label}</Label>}
      <StyledSelect
        classNamePrefix="react-select"
        placeholder={placeholder}
        isDisabled={disabled}
        name={field.name}
        options={options}
        isMulti={isMulti}
        isSearchable={isSearchable}
        onBlur={field.onBlur}
        onChange={option => {
          form.setFieldValue(field.name, option);
          if (onChanged) {
            onChanged(option);
          }
        }}
        value={field.value}
      />
      <ErrorMessage name={field.name}>
        {msg => {
          return (
            <Span mt={2} color="error" textAlign="right">
              {msg}
            </Span>
          );
        }}
      </ErrorMessage>
    </Box>
  );
};

export const CleanFormSelect = tag(StyledFormSelect, ['display', 'alignItems', 'flexDirection', 'justifyContent']);

export default CleanFormSelect;

StyledFormSelect.defaultProps = {
  options: [],
  mb: 3,
  flex: 1,
  minWidth: '150px',
};



// WEBPACK FOOTER //
// ./src/components/formElements/StyledFormSelect.tsx